import { render } from "./TableContracts.vue?vue&type=template&id=d225e81e&scoped=true"
import script from "./TableContracts.vue?vue&type=script&lang=js"
export * from "./TableContracts.vue?vue&type=script&lang=js"

import "./TableContracts.vue?vue&type=style&index=0&id=d225e81e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d225e81e"]])

export default __exports__